export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10039.c38f4d7c.jpg";